import goldPNG from './img/gold.png';
import silverPNG from './img/silver.png';
import bronzePNG from './img/bronze.png';

// bronze
import bronzeTop1D from './img/bronzeTop1D.webp';
import bronzeTop2D from './img/bronzeTop2D.webp';
import bronzeTop3D from './img/bronzeTop3D.webp';
import bronzeTop1M from './img/bronzeTop1M.webp';
import bronzeTop2M from './img/bronzeTop2M.webp';
import bronzeTop3M from './img/bronzeTop3M.webp';

// silver
import silverTop1D from './img/silverTop1D.webp';
import silverTop2D from './img/silverTop2D.webp';
import silverTop3D from './img/silverTop3D.webp';

import silverTop1M from './img/silverTop1M.webp';
import silverTop2M from './img/silverTop2M.webp';
import silverTop3M from './img/silverTop3M.webp';

// provider silver
import providerSilverTop1D from './img/providerSilverTop1D.webp';
import providerSilverTop2D from './img/providerSilverTop2D.webp';
import providerSilverTop3D from './img/providerSilverTop3D.webp';
import providerSilverTop1M from './img/providerSilverTop1M.webp';
import providerSilverTop2M from './img/providerSilverTop2M.webp';
import providerSilverTop3M from './img/providerSilverTop3M.webp';

// proveedores_gold
import mersedesWebp from './img/providerGoldTop1D.webp';
import japanWebp from './img/providerGoldTop2D.webp';
import kawasakiWebp from './img/providerGoldTop3D.webp';
import mersedesmWebp from './img/providerGoldTop1M.webp';
import japanmWebp from './img/providerGoldTop2M.webp';
import kawasakimWebp from './img/providerGoldTop3M.webp';

// pragmatic
import pragmatic2000Webp from './img/pragmatic2000.webp';
import pragmatic4000Webp from './img/pragmatic4000.webp';
import pragmatic7000Webp from './img/pragmatic7000.webp';
import pragmaticMotoBajajWebp from './img/pragmaticmotobajaj.webp';
import pragmaticPeugeotWebp from './img/pragmaticpeugeot.webp';

import pragmatic2000mWebp from './img/pragmatic2000m.webp';
import pragmatic4000mWebp from './img/pragmatic4000m.webp';
import pragmatic7000mWebp from './img/pragmatic7000m.webp';
import pragmaticMotoBajajmWebp from './img/pragmaticmotobajajm.webp';
import pragmaticPeugeotmWebp from './img/pragmaticpeugeotm.webp';

const awardsList = rank => {
  switch (rank) {
    case 'pragmatic': {
      return [
        {
          key: 0,
          imgDesk: pragmatic7000Webp,
          imgMob: pragmaticPeugeotmWebp,
        },
        {
          key: 1,
          imgDesk: pragmaticPeugeotWebp,
          imgMob: pragmatic7000mWebp,
        },
        {
          key: 2,
          imgDesk: pragmatic2000Webp,
          imgMob: pragmatic2000mWebp,
        },
        {
          key: 3,
          imgDesk: pragmatic4000Webp,
          imgMob: pragmaticMotoBajajmWebp,
        },
        {
          key: 4,
          imgDesk: pragmaticMotoBajajWebp,
          imgMob: pragmatic4000mWebp,
        },
        {
          key: 5,
          imgDesk: pragmatic2000Webp,
          imgMob: pragmatic2000mWebp,
        },
      ];
    }
    case rankTypes.bronze: {
      return [
        {
          key: 0,
          imgDesk: bronzeTop2D,
          imgMob: bronzeTop1M,
        },
        {
          key: 1,
          imgDesk: bronzeTop1D,
          imgMob: bronzeTop2M,
        },
        {
          key: 2,
          imgDesk: bronzeTop3D,
          imgMob: bronzeTop3M,
        },
      ];
    }
    case rankTypes.silver: {
      return [
        {
          key: 0,
          imgDesk: silverTop2D,
          imgMob: silverTop1M,
        },
        {
          key: 1,
          imgDesk: silverTop1D,
          imgMob: silverTop2M,
        },
        {
          key: 2,
          imgDesk: silverTop3D,
          imgMob: silverTop3M,
        },
      ];
    }
    case rankTypes.providerSilver: {
      return [
        {
          key: 0,
          imgDesk: providerSilverTop2D,
          imgMob: providerSilverTop1M,
        },
        {
          key: 1,
          imgDesk: providerSilverTop1D,
          imgMob: providerSilverTop2M,
        },
        {
          key: 2,
          imgDesk: providerSilverTop3D,
          imgMob: providerSilverTop3M,
        },
      ];
    }
    case rankTypes.providerGold: {
      return [
        {
          key: 0,
          imgDesk: japanWebp,
          imgMob: mersedesmWebp,
        },
        {
          key: 1,
          imgDesk: mersedesWebp,
          imgMob: japanmWebp,
        },
        {
          key: 2,
          imgDesk: kawasakiWebp,
          imgMob: kawasakimWebp,
        },
      ];
    }
    default: {
      return [];
    }
  }
};

const rankTypes = {
  providerGold: 'proveedores_gold',
  providerSilver: 'proveedores_silver',
  gold: 'gold',
  silver: 'silver',
  bronze: 'bronze',
};

const rankImages = {
  [rankTypes.gold]: goldPNG,
  [rankTypes.silver]: silverPNG,
  [rankTypes.bronze]: bronzePNG,
  [rankTypes.gold]: goldPNG,
  [rankTypes.providerSilver]: silverPNG,
  [rankTypes.providerGold]: goldPNG,
};

const rankImagesByPosition = {
  1: goldPNG,
  2: silverPNG,
  3: bronzePNG,
};

export { awardsList, rankImages, rankTypes, rankImagesByPosition };
